import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgColumns = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5 0.0111542H1.5C0.671573 0.0111542 0 0.682727 0 1.51115V22.5112C0 23.3396 0.671573 24.0112 1.5 24.0112H5C5.82843 24.0112 6.5 23.3396 6.5 22.5112V1.51115C6.5 0.682727 5.82843 0.0111542 5 0.0111542Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.75 0.0111542H10.25C9.42157 0.0111542 8.75 0.682727 8.75 1.51115V22.5112C8.75 23.3396 9.42157 24.0112 10.25 24.0112H13.75C14.5784 24.0112 15.25 23.3396 15.25 22.5112V1.51115C15.25 0.682727 14.5784 0.0111542 13.75 0.0111542Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.5 0.0111542H19C18.1716 0.0111542 17.5 0.682727 17.5 1.51115V22.5112C17.5 23.3396 18.1716 24.0112 19 24.0112H22.5C23.3284 24.0112 24 23.3396 24 22.5112V1.51115C24 0.682727 23.3284 0.0111542 22.5 0.0111542Z",
			fill: "currentColor"
		})
	]
});
export { SvgColumns as ReactComponent };
